import classNames from 'clsx';
import styles from '../../embed.style';
import type { VideoEmbedADT } from '../../type';

export function qq(input: VideoEmbedADT): VideoEmbedADT {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host === 'v.qq.com') {
    const pathname = input.pathname;
    const split = pathname.split('/');
    const id = (
      split[split.length - 1] === '' ? split[split.length - 2] : split[split.length - 1]
    ).replace('.html', '');
    if (!id) return input;
    return (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          width="100%"
          height="100%"
          frameBorder="0"
          src={`https://v.qq.com/txp/iframe/player.html?vid=${id}`}
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  return input;
}
